import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
    name: 'add'
})
export class AddPipe implements PipeTransform {
    transform(items: any[], item: any) {
        if (item && items)
         items.push(item);
        return items;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/sui/sui.util/sui.util.add.pipe.ts